export const formatPrice = (price) => {
   
    let tempPrice = price;
    if(!price){
        return 0
    }
    if( tempPrice === '' || tempPrice === undefined ){
        return 0
    }else{
        let newPrice = price.toString();
        let StringPrice = ''
        for (let i = 1; i < parseInt((newPrice.length-1)/3)+2; i++) {
            let start = newPrice.length-(i*3);
            let end = newPrice.length - ((i-1)*3);
            if (start < 0){
                tempPrice = newPrice.slice(0,end)
            } else {
                tempPrice = newPrice.slice(start,end)
            }
            if (i === 1){
                StringPrice = tempPrice;
            } else {
                StringPrice = tempPrice + ',' + StringPrice;
            }
        }
        return StringPrice;
    }
}


export const removeFormatPrice = (price) => {
    let tempPrice = price;
    if(!price){
        return ""
    }
    if( tempPrice === '' || tempPrice === undefined ){
        return ""
    }else{
        let newPrice = price.toString();
        let StringPrice = ''
        for (let i = 0; i < newPrice.length; i++) {
            if(newPrice[i] !== ','){
                StringPrice = StringPrice + newPrice[i];
            }
        }
        return StringPrice;
    }
}